class LiveOperatorsResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, config) {
        return (headers = {}) =>
            $resource(
                `${config.contentApi.url}/v1/operators`,
                { id: "@id" },
                {
                    get: {
                        method: "GET",
                        headers,
                        isArray: true
                    }
                }
            );
    }
}

class LiveSaleResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, config) {
        return (headers = {}) =>
            $resource(
                `${config.contentApi.url}/v1/sales/:id/live`,
                { id: "@id" },
                {
                    get: {
                        method: "GET",
                        headers
                    },
                    patch: {
                        method: "PATCH",
                        headers
                    }
                }
            );
    }
}

angular
    .module("thor.core.live.resource", [])
    .factory("liveOperatorsResource", LiveOperatorsResource)
    .factory("liveSaleResource", LiveSaleResource);
